import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { foldersKeys } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUnarchiveChecklistTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['unarchiveChecklistTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.unArchiveChecklistTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(checklistTemplateKeys.getTemplate._def)
      queryClient.invalidateQueries(foldersKeys._def)
    },
  })
}
